/**
 * Date formatting utilities
 */

/**
 * Formats a date to locale-specific date and time string
 * @param date - Date to format (Date object, timestamp, or ISO string)
 * @returns Formatted date string
 */
export function formatDateTime(date: Date | string | number): string {
  const dateObject = new Date(date);
  return dateObject.toLocaleString();
}

/**
 * Formats a date to locale-specific date string (no time)
 * @param date - Date to format
 * @returns Formatted date string
 */
export function formatDate(date: Date | string | number): string {
  const dateObject = new Date(date);
  return dateObject.toLocaleDateString();
}

/**
 * Formats a date to locale-specific time string (no date)
 * @param date - Date to format
 * @returns Formatted time string
 */
export function formatTime(date: Date | string | number): string {
  const dateObject = new Date(date);
  return dateObject.toLocaleTimeString();
}
